import UserManagementService from '../services/UserManagement.service';

export const COPY_MODES = { Add: 'add', Replace: 'replace' };

const MAX_LISTED_NAMES = 10;

export const formatNames = (names) => {
  const listed = names.slice(0, MAX_LISTED_NAMES).join(', ');
  const hiddenCount = names.length - MAX_LISTED_NAMES;
  return hiddenCount > 0 ? `${listed} and ${hiddenCount} more` : listed;
};

// The source's own id is excluded because every user lists themselves in rbac and the
// target must not gain a grant to itself. Ids outside the loaded list are dropped
// because the backend rejects grants the caller does not administer.
// Array.from, not spread: the babel spread transform runs in loose mode and breaks Set spread.
export function resolveSourceGrantIds(sourceUser, users) {
  const knownIds = new Set(users.map((user) => user.customerId));
  const grantIds = (sourceUser.roleBasedAccessControl || [])
    .map(Number)
    .filter((id) => id !== sourceUser.customerId && knownIds.has(id));
  return Array.from(new Set(grantIds)).sort((a, b) => a - b);
}

// Replace never removes grants outside knownIds: the admin cannot see them, so cannot judge them.
export function planCopy(targetId, targetCurrentIds, sourceGrantIds, mode, knownIds) {
  const currentIds = targetCurrentIds.filter(Number.isFinite);
  const current = new Set(currentIds);
  const toAdd = sourceGrantIds.filter((id) => !current.has(id));
  if (mode !== COPY_MODES.Replace) {
    return { toAdd, toRemove: [] };
  }
  const wanted = new Set(sourceGrantIds);
  const removable = currentIds.filter((id) => id !== targetId && !wanted.has(id) && knownIds.has(id));
  return { toAdd, toRemove: Array.from(new Set(removable)) };
}

// Adds first, so a failed add leaves the target unchanged.
export async function copyRbacToUser(targetId, targetCurrentIds, sourceGrantIds, mode, knownIds) {
  const { toAdd, toRemove } = planCopy(targetId, targetCurrentIds, sourceGrantIds, mode, knownIds);
  if (toAdd.length) {
    await UserManagementService.batchAddRbacPermissions(targetId, toAdd);
  }
  if (toRemove.length) {
    await UserManagementService.batchRemoveRbacPermissions(targetId, toRemove);
  }
}
